export default [
  {
    path: '/guide',
    component: () => import('@/views/guide/guide.vue'),
    name: 'guide',
    meta: {
      title: '息屏导航引导',
      backgroundClass: 'bg-gray',
    },
  },
];
